import { render, staticRenderFns } from "./ProductPropertyTemplateGroupItemsList.vue?vue&type=template&id=7886497c"
import script from "./ProductPropertyTemplateGroupItemsList.vue?vue&type=script&lang=js"
export * from "./ProductPropertyTemplateGroupItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports